import { render, staticRenderFns } from "./switchIdentity.vue?vue&type=template&id=a1c396f6&scoped=true&"
import script from "./switchIdentity.vue?vue&type=script&lang=babel&"
export * from "./switchIdentity.vue?vue&type=script&lang=babel&"
import style0 from "./switchIdentity.vue?vue&type=style&index=0&id=a1c396f6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c396f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VDivider,VList,VListItem,VListItemTitle,VRow,VTextField})
